/**
 * System default grace window when a practice has configured a fee policy
 * but not an explicit grace value. PRD-fixed at 24 hours.
 */
export const DEFAULT_CANCELLATION_GRACE_HOURS = 24;
/** Inclusive bounds for `cancellationGraceHours`. */
export const CANCELLATION_GRACE_HOURS_MIN = 0;
export const CANCELLATION_GRACE_HOURS_MAX = 24 * 14; // two weeks is plenty
/** Inclusive bounds for the `fixed` amount (cents). */
export const CANCELLATION_FIXED_AMOUNT_CENTS_MIN = 0;
export const CANCELLATION_FIXED_AMOUNT_CENTS_MAX = 10_000_00; // 10 000 €
/** Inclusive bounds for `percentage`. */
export const CANCELLATION_PERCENT_MIN = 0;
export const CANCELLATION_PERCENT_MAX = 100;
//# sourceMappingURL=cancellation-fee-policy.types.js.map